/* ============================================================
   Sticky add to cart (movil)

   Pixel-safe: no llama a /cart/add.js. Hace scroll al formulario y
   dispara .click() sobre el [name="add"] nativo, para que el evento
   AddToCart del pixel y el cart drawer del tema se disparen desde el
   mismo lugar de siempre.
   ============================================================ */

(function () {
  'use strict';

  var MQ = '(max-width: 768px)';

  function money(cents) {
    /* El brief pide toLocaleString('es-MX'), no shop.money_format. */
    return '$' + (cents / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function init() {
    var bar = document.querySelector('[data-satc]');
    if (!bar || bar.getAttribute('data-satc-ready') === '1') {
      return;
    }

    var addBtn = document.querySelector('form[action*="/cart/add"] [name="add"]');
    if (!addBtn) {
      return;
    }
    bar.setAttribute('data-satc-ready', '1');

    var form = addBtn.closest('form');
    var btn = bar.querySelector('[data-satc-btn]');
    var priceEl = bar.querySelector('[data-satc-price]');
    var variantEl = bar.querySelector('[data-satc-variant]');

    /* --- Mostrar solo cuando el boton nativo sale de pantalla --- */
    var visible = false;

    function setVisible(v) {
      if (v === visible) {
        return;
      }
      visible = v;
      bar.hidden = !v;
      bar.classList.toggle('is-in', v);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var matches = window.matchMedia(MQ).matches;
        setVisible(matches && !e.isIntersecting && !addBtn.disabled);
      }, { rootMargin: '0px 0px -40px 0px' }).observe(addBtn);
    }

    /* --- Reflejar la variante elegida --- */
    function currentVariantId() {
      var input = form && form.querySelector('[name="id"]');
      return input ? input.value : null;
    }

    function syncFromVariant(variant) {
      if (!variant) {
        return;
      }
      if (priceEl && typeof variant.price === 'number') {
        priceEl.textContent = money(variant.price);
      }
      if (variantEl && variant.title && variant.title !== 'Default Title') {
        variantEl.textContent = variant.title;
      }
      if (btn) {
        btn.disabled = variant.available === false;
      }
    }

    /* El tema dispara este evento al cambiar de variante. */
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) {
        syncFromVariant(e.detail.variant);
      }
    });

    /* Respaldo: si el tema no emite el evento, observamos el input id. */
    var lastId = currentVariantId();
    window.setInterval(function () {
      var id = currentVariantId();
      if (id && id !== lastId) {
        lastId = id;
        var node = document.querySelector('[data-product-json], [data-variant-json]');
        if (!node) {
          return;
        }
        try {
          var data = JSON.parse(node.textContent);
          var list = data.variants || (data.product && data.product.variants) || [];
          for (var i = 0; i < list.length; i++) {
            if (String(list[i].id) === String(id)) {
              syncFromVariant(list[i]);
              break;
            }
          }
        } catch (err) {
          /* Sin JSON del producto nos quedamos con el precio inicial. */
        }
      }
    }, 400);

    /* --- Accion --- */
    if (btn) {
      btn.addEventListener('click', function () {
        /* Si falta elegir talla, no agregamos: llevamos al selector. */
        var picker = document.querySelector('.variant-wrapper, [data-variant-wrapper], .variant__label');
        var needsOption = form && form.querySelector('[name="id"]') && !currentVariantId();

        if (needsOption && picker) {
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          picker.classList.add('satc-highlight');
          window.setTimeout(function () {
            picker.classList.remove('satc-highlight');
          }, 1600);
          return;
        }

        if (addBtn.disabled) {
          return;
        }

        addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        /* El click nativo mantiene intacto el evento AddToCart del pixel. */
        window.setTimeout(function () {
          addBtn.click();
        }, 320);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
